import { render, staticRenderFns } from "./HomeContentTopicPreview.vue?vue&type=template&id=095ec7cc&scoped=true&"
import script from "./HomeContentTopicPreview.vue?vue&type=script&lang=js&"
export * from "./HomeContentTopicPreview.vue?vue&type=script&lang=js&"
import style0 from "./HomeContentTopicPreview.vue?vue&type=style&index=0&id=095ec7cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095ec7cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
